import { render, staticRenderFns } from "./CreatePersonAction.vue?vue&type=template&id=0a8ad3ed"
import script from "./CreatePersonAction.vue?vue&type=script&lang=js"
export * from "./CreatePersonAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports